import { render, staticRenderFns } from "./ChannelGroupReportTable.vue?vue&type=template&id=892803a8&scoped=true&"
import script from "./ChannelGroupReportTable.vue?vue&type=script&lang=js&"
export * from "./ChannelGroupReportTable.vue?vue&type=script&lang=js&"
import style0 from "./ChannelGroupReportTable.vue?vue&type=style&index=0&id=892803a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892803a8",
  null
  
)

export default component.exports